"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAbsoluteLink = exports.createExternalLinkUtils = exports.getDocumentLinkProps = void 0;
const tslib_1 = require("tslib");
const links_1 = require("./links");
const linkPatternUtils_1 = require("./linkPatternUtils");
const lodash_1 = tslib_1.__importDefault(require("lodash"));
const ANCHOR_NAME_TO_TYPE = {
    top: 'SCROLL_TO_TOP',
    bottom: 'SCROLL_TO_BOTTOM',
};
const getEscapedQueries = (queryParams) => ({
    subject: encodeURIComponent(queryParams.get('subject') || ''),
    body: encodeURIComponent(queryParams.get('body') || ''),
    bcc: encodeURIComponent(queryParams.get('bcc') || ''),
    cc: encodeURIComponent(queryParams.get('cc') || ''),
});
const getMailtoLinkProps = (mailtoUrl) => {
    const [, recipient, queries] = linkPatternUtils_1.MAILTO_URL_REGEXP.exec(mailtoUrl);
    const escapedQuery = getEscapedQueries(new URLSearchParams(queries));
    return {
        type: 'EmailLink',
        href: (0, links_1.resolveEmailLink)({ recipient, ...escapedQuery }),
        target: '_self',
    };
};
const getPhoneLinkProps = (telUrl) => {
    const [, phoneNumber] = linkPatternUtils_1.PHONE_URL_REGEXP.exec(telUrl);
    return {
        type: 'PhoneLink',
        href: (0, links_1.resolvePhoneLink)({ phoneNumber }),
        target: '_self',
    };
};
const getExternalLinkProps = (url, target = '_blank', rel = 'noopener') => {
    return {
        type: 'ExternalLink',
        href: url,
        target,
        rel,
    };
};
const getDocumentLinkProps = (documentUrl, metaSiteId, userFileDomainUrl = 'filesusr.com/', externalBaseUrl = '', isPremiumDomain = false) => {
    const [, docId, name] = linkPatternUtils_1.DOCUMENT_URL_REGEXP.exec(documentUrl) || linkPatternUtils_1.LEGACY_DOCUMENT_URL_REGEXP.exec(documentUrl);
    return {
        type: 'DocumentLink',
        href: (0, links_1.resolveDocumentLink)({ docId, name: name || '', indexable: false }, metaSiteId, userFileDomainUrl, externalBaseUrl, isPremiumDomain),
        target: '_blank',
        docInfo: {
            docId,
            name,
        },
    };
};
exports.getDocumentLinkProps = getDocumentLinkProps;
class UnsupportedLinkTypeError extends Error {
    constructor() {
        super('Unsupported link type');
        this.name = 'UnsupportedLinkTypeError';
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, UnsupportedLinkTypeError);
        }
    }
}
const createExternalLinkUtils = ({ metaSiteId = 'unknown', isMobileView = false, }) => {
    const BASE_DOCUMENTS_URL = `https://${metaSiteId}.filesusr.com/`;
    const isDocumentHref = (href) => href.startsWith(BASE_DOCUMENTS_URL);
    return {
        isDynamicPage: () => {
            return false;
        },
        isAbsoluteUrl: linkPatternUtils_1.isAbsoluteUrl,
        getImpliedLink: (text) => (0, links_1.getImpliedLink)(text, isMobileView),
        getImpliedLinks: (text, config) => (0, links_1.getImpliedLinks)(text, isMobileView, config),
        getLink: ({ href = '', anchorDataId = '', docInfo, type } = {}) => {
            if ((0, linkPatternUtils_1.isMailtoUrl)(href)) {
                return href;
            }
            if (isDocumentHref(href)) {
                return (0, links_1.getDocumentLink)(docInfo.docId, docInfo.name);
            }
            if ((0, linkPatternUtils_1.isScrollTopOrBottomAnchor)(anchorDataId)) {
                return `#${lodash_1.default.invert(ANCHOR_NAME_TO_TYPE)[anchorDataId]}`;
            }
            const isExternalLink = type === 'ExternalLink';
            if (isExternalLink) {
                return href;
            }
            return href;
        },
        getLinkProps: (url, target, rel) => {
            if ((0, linkPatternUtils_1.isMailtoUrl)(url)) {
                return getMailtoLinkProps(url);
            }
            if ((0, linkPatternUtils_1.isPhoneUrl)(url)) {
                return getPhoneLinkProps(url);
            }
            if ((0, linkPatternUtils_1.isAbsoluteUrl)(url)) {
                return getExternalLinkProps(url, target, rel);
            }
            if ((0, linkPatternUtils_1.isDocumentUrl)(url)) {
                return (0, exports.getDocumentLinkProps)(url, metaSiteId);
            }
            throw new UnsupportedLinkTypeError();
        },
        getLinkUrlFromDataItem: () => {
            throw new Error(`getLinkUrlFromDataItem is not implemented`);
        },
    };
};
exports.createExternalLinkUtils = createExternalLinkUtils;
const isAbsoluteLink = (metaSiteId, { href = '', anchorDataId = '', type }) => {
    return ((0, linkPatternUtils_1.isMailtoUrl)(href) ||
        type === 'ExternalLink' ||
        href.startsWith(`https://${metaSiteId}.filesusr.com/`) ||
        (0, linkPatternUtils_1.isScrollTopOrBottomAnchor)(anchorDataId));
};
exports.isAbsoluteLink = isAbsoluteLink;
//# sourceMappingURL=linkUtils.js.map